<div class="op-dialog">

  <div class="op-header">
    <h2 class="op-title">
      <mat-icon>tune</mat-icon>
      Reconfigurar Cartera
      <span class="tipo-badge">{{ optimalWalletreconfi.nombre }}</span>
    </h2>
    <div class="op-header-actions">
      <button mat-icon-button class="close-button" mat-dialog-close aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="op-content">

    <!-- Cuenta -->
    <div class="section-header">
      <mat-icon class="small-icon">account_balance</mat-icon>
      <span>Cuenta</span>
    </div>

    <div class="fields-grid">
      <label class="field-label">Capital Inicial</label>
      <input type="number" class="dense-input" [(ngModel)]="optimalWalletreconfi.capitalinicial"
          (ngModelChange)="calcularData()">

      <label class="field-label">Tipo Cuenta</label>
      <select class="dense-input" aria-label="Tipo de cuenta"
          [(ngModel)]="optimalWalletreconfi.tipocuenta" (ngModelChange)="onTipoCuentaChange()">
        <option [value]="type" *ngFor="let type of accountType">{{type}}</option>
      </select>

      <label class="field-label">Apalancamiento</label>
      <input type="number" class="dense-input" [(ngModel)]="optimalWalletreconfi.apalancamiento"
          (ngModelChange)="calcularData()" [disabled]="esNominal()" min="1">

      <label class="field-label">Margen Requerido %</label>
      <input type="number" class="dense-input" [(ngModel)]="optimalWalletreconfi.margenRequeridoPor"
          [disabled]="esNominal()">

      <label class="field-label">Control Margin Call %</label>
      <input type="number" class="dense-input" [(ngModel)]="optimalWalletreconfi.controlMarginCall"
          [disabled]="esNominal()">
    </div>

    <!-- Riesgo -->
    <div class="section-header mt-3">
      <mat-icon class="small-icon">shield</mat-icon>
      <span>Riesgo</span>
    </div>

    <div class="fields-grid">
      <label class="field-label">Riesgo Máximo</label>
      <input type="number" class="dense-input" [(ngModel)]="optimalWalletreconfi.riesgomaximo">

      <label class="field-label">Tipo Riesgo</label>
      <select class="dense-input" aria-label="Tipo de riesgo" [(ngModel)]="optimalWalletreconfi.tiporiesgo">
        <option [value]="type" *ngFor="let type of purchaseTypes">{{type}}</option>
      </select>

      <label class="field-label">Valor Riesgo</label>
      <input type="number" class="dense-input" [(ngModel)]="optimalWalletreconfi.riesgo">

      <label class="field-label">Stop Loss</label>
      <input type="number" class="dense-input" [(ngModel)]="optimalWalletreconfi.stopLoss"
          (change)="validateStopLoss()" min="0.001" max="100">
    </div>

    <!-- Costes -->
    <div class="section-header mt-3">
      <mat-icon class="small-icon">payments</mat-icon>
      <span>Costes</span>
    </div>

    <div class="fields-grid">
      <label class="field-label">Comisión Broker Ida y Vuelta</label>
      <input type="number" class="dense-input" [(ngModel)]="optimalWalletreconfi.comisionbroker">

      <mat-checkbox class="field-check" [(ngModel)]="optimalWalletreconfi.chkgastogest" [color]="'primary'">
        <span class="field-label">Gastos Gestión</span>
      </mat-checkbox>
      <input type="number" class="dense-input" [(ngModel)]="optimalWalletreconfi.gastosGestionPor"
          [disabled]="!optimalWalletreconfi.chkgastogest">

      <mat-checkbox class="field-check" [(ngModel)]="optimalWalletreconfi.chkgastoprest" [color]="'primary'">
        <span class="field-label">Gastos Préstamo %</span>
      </mat-checkbox>
      <input type="number" class="dense-input" [(ngModel)]="optimalWalletreconfi.gastosPrestamoPor"
          [disabled]="!optimalWalletreconfi.chkgastoprest">

      <mat-checkbox class="field-check" [(ngModel)]="optimalWalletreconfi.participacion" [color]="'primary'">
        <span class="field-label">Comprar/Vender Fracciones</span>
      </mat-checkbox>
      <span></span>
    </div>

    <div class="alert-no-numbers">
      <div>Riesgo y Tipo de compras no se reconfiguran desde el inicio.</div>
      <div>El stop loss solo reconfigura la tabla de SELECCIONAR MERCADO.</div>
      <div>Tipo de cuenta solo tiene sentido reconfigurarlo después de un Reset de Cartera.</div>
    </div>

  </div>

  <div class="op-actions">
    <button mat-stroked-button class="sync-optima-btn" *ngIf="tieneCarteraOptima()" (click)="sincronizarOptima()"
        [disabled]="sincronizando || guardando"
        matTooltip="Cargar en el formulario los parámetros de la cartera óptima">
      <mat-icon>sync</mat-icon>
      {{ sincronizando ? 'Sincronizando…' : 'Sincronizar óptima' }}
    </button>
    <button mat-stroked-button mat-dialog-close>Cancelar</button>
    <button mat-flat-button color="primary" [disabled]="guardando || !esValido()" (click)="guardar()">
      {{ guardando ? 'Guardando…' : 'Aceptar' }}
    </button>
  </div>

</div>
